import * as angular from 'angular';

export const IdentityProviderToggleComponent: angular.IComponentOptions = {
  controller: class {
    public providerId: string;
    public providerIsDefault: boolean;
    public enabled: boolean;
    public onClick: ($args: { $providerId: string }) => void;

    constructor() {}
    $onInit() {}

    checkBoxClicked() {
      if (!this.providerIsDefault) {
        const $providerId = this.providerId;
        this.onClick({ $providerId });
      }
    }
  },
  controllerAs: 'ctrl',
  bindings: {
    providerId: '<',
    providerIsDefault: '<',
    enabled: '<',
    onClick: '&',
  },
  template: `
    <div class="identity-provider-toggle-container">
      <capra-badge
        ng-if="ctrl.providerIsDefault"
        class="default-label"
        text="DEFAULT"
        type="green"
        tooltip-enable="ctrl.providerIsDefault"
        uib-tooltip="Default option cannot be toggled off."
        tooltip-placement="left"
      ></capra-badge>
      <checkbox-toggle
        ng-click="ctrl.checkBoxClicked()"
        checked="ctrl.enabled"
      />
    </div>
  `,
};
